// import React from 'react';
// import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import SdgScoreClob from './_sdgScoreClob';
import { NaceCodeClobDto, AffinityDto } from 'models/dtoTypes';

const PREFIX = 'DoNoSignificantHarmClob';

const classes = {
  code: `${PREFIX}-code`,
  description: `${PREFIX}-description`,
};

const ItemRoot = styled('div')(() => ({
  position: 'relative',
  width: '100%',
  display: 'flex',
  [`& .${classes.code}`]: {
    width: 60,
    fontWeight: 'bold',
  },
  [`& .${classes.description}`]: {
    flex: 1,
  },
}));

interface IProps {
  title: string;
  sdgId?: string;
  anchor?: string;
  autoHeight?: boolean;
  affinity?: AffinityDto;
  associatedNaceCodes: NaceCodeClobDto[];
}

export default function DoNoSignificantHarmClob(props: IProps): JSX.Element {
  const { title, autoHeight, anchor, sdgId, affinity, associatedNaceCodes } = props;

  const renderSingleListItem = (item: NaceCodeClobDto, index: number) => {
    const { naceCode, description } = item;
    return (
      <ListItem key={index}>
        <ListItemText
          primary={
            <ItemRoot>
              <div className={classes.code}>{naceCode}</div>
              <div className={classes.description}>{description}</div>
            </ItemRoot>
          }
        />
      </ListItem>
    );
  };
  const renderAllListItems = (items: NaceCodeClobDto[]) => {
    return (
      <Box
        sx={{
          width: '100%',
          height: autoHeight ? 'auto' : 200,
          bgcolor: 'background.paper',
          overflowY: autoHeight ? 'hidden' : 'scroll',
          overflowX: 'hidden',
        }}
      >
        <List>{items.map(renderSingleListItem)}</List>
      </Box>
    );
  };

  return (
    <Box
      component="div"
      sx={{
        width: '100%',
        p: 0,
        mt: 1,
        mb: 1,
        border: '2px solid #808080',
      }}
    >
      <SdgScoreClob sdgId={sdgId} anchor={anchor} title={title} affinity={affinity} withBg={true} />
      <Divider sx={{ borderBottom: '2px solid #808080' }} />
      {renderAllListItems(associatedNaceCodes)}
    </Box>
  );
}
